<div class="td-wb-help-container"
     role="dialog"
     aria-labelledby="td-wb-aria-help-title"
     aria-modal="true">
  <div class="td-wb-help__header"
       aria-labelledby="td-wb-aria-help-title">
    @if (showIndex) {
      <span id="td-wb-aria-help-title"
            class="td-wb-help__header-text"
            role="heading"
            aria-level="1"
            translate="tdWb.help.TITLE">
      </span>
      <button class="td-wb-help__header-close-button"
              tdWbButton
              tdWbButtonType="icon"
              tabindex="0"
              [attr.aria-label]="'tdWb.help.CLOSE' | tdWbTranslate"
              (click)="close()">
        <td-wb-icon iconId="close--small"
                    size="15" />
      </button>
    }
    @if (!showIndex) {
      <h1 id="td-wb-aria-help-title"
          class="td-wb-vh"
          translate="tdWb.help.TITLE"></h1>
      <a class="td-wb-help__header-content td-wb-help__header-button"
         role="button"
         tabindex="0"
         href=""
         (click)="closeContent()">
        <td-wb-icon iconId="caret-left--small"
                    size="16" />
        <span class="td-wb-help__header-text td-wb-help__header-text--content"
              translate="tdWb.help.TITLE"></span>
        <span class="td-wb-vh">
          (<span translate="tdWb.help.BACK_TOPICS"></span>)
        </span>
      </a>
      <button class="td-wb-help__header-close-button"
              tdWbButton
              tdWbButtonType="icon"
              tabindex="0"
              [attr.aria-label]="'tdWb.help.CLOSE' | tdWbTranslate"
              (click)="close()">
        <td-wb-icon iconId="close--small"
                    size="15" />
      </button>
    }
  </div>
  <div [ngClass]="isIOS ? 'td-wb-help-container-inner td-wb-help-mobile__content' : 'td-wb-help-container-inner'">
    @if (showIndex) {
      <div class="td-wb-help__index"
           (swipeleft)="swipeLeft()">
        @for (topic of topics; track trackByTopicId($index, topic); let isFirst = $first) {
          <a class="td-wb-help__index-item"
             tabindex="0"
             role="button"
             href=""
             [tdWbFocus]="isFirst"
             (click)="showContent(topic)"
             [attr.aria-pressed]="topic.id === currentTopic?.id"
             [attr.id]="'td-wb-help__index-item-' + topic.id">
            <span [innerText]="topic.title"></span>
            <td-wb-icon class="td-wb-help__index-item-icon"
                        iconId="caret-right--small"
                        size="16" />
          </a>
        }
      </div>
    }
    @if (!showIndex) {
      <div class="td-wb-help__content"
           tdWbHelpScroller
           (loadMore)="loadMore($event)"
           (swipeleft)="swipeLeft()">
        @if (hasReachedTopicTop() && hasMoreThanOneLink()) {
          <td-wb-help-article-index (articleSelected)="articleSelected($event)"
            [articles]="articles"
            [topic]="currentTopic" />
        }
        @for (article of articles; track trackByArticleId($index, article); let isFirst = $first; let isLast = $last) {
          <td-wb-help-mobile-article [id]="article.id"
                                     [articleId]="article.id"
                                     [hasFocus]="hasFocus(article.id)"
                                     [articleContent]="article.html"
                                     (indexId)="focusOn($event)"
                                     class="td-wb-help-mobile-article"
                                     [ngClass]="{ 'td-wb-help__bottom-article': isLast && hasReachedTopicBottom(),
                                                'td-wb-help__article': !isFirst }" />
          @if (!isLast) {
            <div class="td-wb-help-section-divider"
            ></div>
          }
        }
        @if (loading) {
          <td-wb-loading-indicator position="inline" />
        }
      </div>
    }
  </div>
</div>
